import React, { useState, useEffect, useRef } from "react";
import { getUserInfo } from "@/apis/user";
import { cloneDeep } from "lodash";
import eventBus from "@/event/event";
import { useNavigate } from 'react-router-dom';

import { useCryptoStore } from '@/store/cryptoStore';

export const defaultPayCountObj = {
    recharge: {
      pay: 0,
      restTime: '',
      restPay: 0
    },
    subscribe: {
      pay: 0,
      restTime: '',
      restPay: 0
    },
    gift: {
      pay: 0,
      restTime: '',
      restPay: 0
    },
    old: {
      pay: 0,
      restTime: '',
      restPay: 0
    }
};

const delay2 = 1000 * 10

export const useCheckVip = (userId) => {
    const [userInfo, setUserInfo] = useState({} as any)
    const [payCountObj, setPayCountObj] = useState(defaultPayCountObj)
    const id2 = useRef(null)

    const { handleGetCryptoMessage } = useCryptoStore()
  
    const checkVip = async () => {
      const result = await getUserInfo()
                              .catch((error) => {
                                  clearInterval(id2.current)
                                  // eventBus.emit('logout')
                              })
      // console.log(result)
      if (result) {    
          setUserInfo(result)
          if (Array.isArray(result?.balance) && result?.balance?.length) {
            const sevenDays = 7 * 24 * 60 * 60 * 1000;
            const newObj = cloneDeep(defaultPayCountObj)
            // console.log('array', result?.balance)
            result?.balance.forEach(item => {
              const currentDate = new Date();
              if (item?.expired_at && new Date(item?.expired_at).getTime() < currentDate.getTime()) {
                return
              }
              if (typeof item.balance !== 'number') {
                return
              }
              if (item?.expired_at && (new Date(item?.expired_at).getTime() < currentDate.getTime() + sevenDays)) {
                const expiredDate = new Date(item?.expired_at)
                if (item?.source === 'gift') {
                  newObj.gift.restPay += item?.balance
                  newObj.gift.restTime = `${expiredDate.getFullYear()}/${expiredDate.getMonth() + 1}/${expiredDate.getDate()}`
                  newObj.gift.pay += item?.balance
                }
                if (item?.source === 'vip') {
                  newObj.subscribe.restPay += item?.balance
                  newObj.subscribe.restTime = `${expiredDate.getFullYear()}/${expiredDate.getMonth() + 1}/${expiredDate.getDate()}`
                  newObj.subscribe.pay += item?.balance
                }
                if (item?.source === 'top-up') {
                  newObj.recharge.restPay += item?.balance
                  newObj.recharge.restTime = `${expiredDate.getFullYear()}/${expiredDate.getMonth() + 1}/${expiredDate.getDate()}`
                  newObj.recharge.pay += item?.balance
                }
                if (item?.source === 'old_version_vip') {
                  newObj.old.restPay += item?.balance
                  newObj.old.restTime = `${expiredDate.getFullYear()}/${expiredDate.getMonth() + 1}/${expiredDate.getDate()}`
                  newObj.old.pay += item?.balance
                }
                return
              }
              if (item?.expired_at) {
                if (item?.source === 'gift') {
                  newObj.gift.pay += item?.balance
                }
                if (item?.source === 'vip') {
                  newObj.subscribe.pay += item?.balance
                }
                if (item?.source === 'top-up') {
                  newObj.recharge.pay += item?.balance
                }
                if (item?.source === 'old_version_vip') {
                  newObj.old.pay += item?.balance
                }
              }
            })
            // console.log('newObj', newObj)
            setPayCountObj(newObj)
          } else {
            setPayCountObj(defaultPayCountObj)
          }
      } else {
          // setUserInfo({})
          setPayCountObj(defaultPayCountObj)
      }
    }
  
    useEffect(() => {
      // console.log('userId,', userId)
      if (userId) {
          checkVip()
      }  
    }, [userId])

    useEffect(() => {
      const work = async (token) => {
        await localStorage.setItem('userInfo', JSON.stringify({ user_id: `token_${token}`, token}));
        await checkVip()
      }

      // if (userId?.indexOf('token_') !== -1) {
        const hash = window.location.hash; // #/page?name=john
        const indexF = hash.indexOf('userId=')
        const queryParamsUserId = indexF >= 0 ? hash.slice(indexF + 7) : ''
        if (queryParamsUserId) {
          // url 有 token
          try {
            const urlGetResToken = handleGetCryptoMessage(queryParamsUserId)
            console.log('urlGetResToken', urlGetResToken)
            if (urlGetResToken) {
              work(urlGetResToken)
            }
          } catch (error) {
            setUserInfo({})
            setPayCountObj(defaultPayCountObj)
          }
        } else {
          setUserInfo({})
          setPayCountObj(defaultPayCountObj)
        }
      // }
    }, [userId])
  
    useEffect(() => {
      if (userId) {
          clearInterval(id2.current)
          id2.current = setInterval(checkVip, delay2);
          return () => {
            clearInterval(id2.current)
          };
      }
    }, [userId]);
  
    return {
        userOtherInfo: userInfo,
        payCountObj
    }
  }